import { FormEvent, useEffect, useState } from 'react';
import { SettingsApi } from '../../api/resources';
import { ApiError } from '../../api/client';
import { useToast } from '../../context/ToastContext';

export function Settings() {
  const { notify } = useToast();
  const [wastePercentage, setWastePercentage] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    SettingsApi.getWastePercentage()
      .then((r) => setWastePercentage(String(r.wastePercentage)))
      .finally(() => setLoading(false));
  }, []);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSaving(true);
    try {
      await SettingsApi.setWastePercentage(Number(wastePercentage));
      notify('Merma global actualizada. Se aplicara a las nuevas recetas.', 'success');
    } catch (err) {
      notify(err instanceof ApiError ? err.message : 'No fue posible guardar la configuracion.', 'error');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <h1>Configuracion de merma global</h1>
      <p className="text-muted">
        Este porcentaje se usa como valor por defecto al crear nuevas recetas. Cada receta puede ajustar su propio porcentaje de merma desde su pagina de
        detalle.
      </p>
      <div className="card">
        {loading ? (
          <div className="loading-block">Cargando...</div>
        ) : (
          <form onSubmit={handleSubmit} noValidate>
            <div className="field" style={{ maxWidth: 260 }}>
              <label htmlFor="waste">Merma global por defecto (%)</label>
              <input
                id="waste"
                type="number"
                min={0}
                max={100}
                step="0.01"
                required
                value={wastePercentage}
                onChange={(e) => setWastePercentage(e.target.value)}
              />
            </div>
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Guardando...' : 'Guardar'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
